module.exports = __webpack_public_path__ + "static/media/app_logo.6c7b8c07.png";